import initializeNumberAnimation from "../functions/initializeNumberAnimation";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.static_pages.about").length) return;
  const initFadeInAnimation = () => {
    const fadeInElements = document.querySelectorAll(".jsFadeIn");

    if (!fadeInElements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("scrollin");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    fadeInElements.forEach((element) => {
      observer.observe(element);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeNumberAnimation();
      initFadeInAnimation();
    });
  } else {
    initializeNumberAnimation();
    initFadeInAnimation();
  }
});
